import { render, staticRenderFns } from "./UserRoles.vue?vue&type=template&id=427ccdfa&"
import script from "./UserRoles.vue?vue&type=script&lang=js&"
export * from "./UserRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('427ccdfa')) {
      api.createRecord('427ccdfa', component.options)
    } else {
      api.reload('427ccdfa', component.options)
    }
    module.hot.accept("./UserRoles.vue?vue&type=template&id=427ccdfa&", function () {
      api.rerender('427ccdfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/Admin/UserRoles.vue"
export default component.exports